import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo, } from 'react';
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { preventDefault } from 'shared/hooks/utils';
import { ExpandMoreRounded } from '@mui/icons-material';
import { ResponsiveIcon } from 'console/shared/components/icon/responsive';
import { DeviceConfig } from 'console/shared/contexts/device/config/types';
import { ControlButton } from 'console/shared/components/buttons/control';
import { getVehicleControlIconWithLabel } from './utils';
import { useVehicleControl } from '../provider';
import { noop } from 'ts-essentials';
import { useAction } from 'shared/hooks/redux/hooks';
import { useCustomControl } from 'shared/components/panels/custom-controls/custom-controls-card/provider';
export const VehicleControlButton = memo(function VehicleControlButton(props) {
    const { label: parent_label, onDisabledClick, disabled, menu, openMenu, showed_menu_count, is_custom, onClickCustomButton, } = props;
    const { control_state, active, loading, onClick, fail, fail_message } = useVehicleControl();
    const { is_active } = useCustomControl();
    const { label, icon } = useMemo(() => getVehicleControlIconWithLabel(control_state), [control_state]);
    const { can_control_device } = useContext(DeviceConfig);
    const onButtonClick = useAction(onClick);
    const { palette } = useTheme();
    const onOpenMenuClick = useCallback((event) => {
        preventDefault(event);
        if (openMenu) {
            openMenu(event);
        }
    }, [openMenu]);
    const _disabled = useMemo(() => !can_control_device || disabled, [can_control_device, disabled]);
    const background_color = useMemo(() => (!_disabled ? palette.background.paper : palette.background.default), [palette]);
    const button_color = useMemo(() => {
        if (control_state == 'autostart-webasto-turned-on') {
            return palette.info.main;
        }
        if (control_state == 'autostart-webasto-turned-off' && loading) {
            return palette.info.dark;
        }
        return palette.primary.main;
    }, [palette, control_state, loading]);
    return (_jsxs(_Fragment, { children: [_jsx(ControlButton, { onClick: is_custom ? onClickCustomButton ?? noop : onButtonClick, background_color: background_color, onDisabledClick: onDisabledClick, loading: loading ?? false, disabled: _disabled, active: is_custom && is_active ? is_active : active, color: button_color, fail: fail, fail_message: fail_message, data_tooltip: "vehicle-control-card", sx: {
                    border: `1px solid rgb(0,0,0,0.12)`,
                }, children: _jsxs(Box, { display: "flex", alignItems: "center", columnGap: 1, height: "100%", flexDirection: "column", justifyContent: "center", children: [_jsxs(Box, { minHeight: 35, display: "flex", columnGap: 1, alignItems: "center", justifyContent: "center", flexDirection: "column", fontSize: "0.7em", children: [icon, _jsx(Typography, { textTransform: "capitalize", children: parent_label ?? label })] }), Number(showed_menu_count) > 0 && (_jsx(IconButton, { onClick: onOpenMenuClick, sx: {
                                p: 0.5,
                                position: 'absolute',
                                right: '20%',
                                top: '15%',
                            }, color: "inherit", disabled: !can_control_device, size: "large", children: _jsx(ResponsiveIcon, { fontSize: "0.8em", Icon: ExpandMoreRounded, color: "inherit" }) }))] }) }), menu] }));
});
